import app from '../../../app';
import projectsModel from '../../../models/projects';
import globalStore from '../../../store/main';

function onTaskCommentCreated(event) {
  const allGanttIds = projectsModel.getAllProjects().map(o => o.id);

  event.data.comments.forEach(comment => {
    if (allGanttIds.includes(comment.projectId)) {
      globalStore.dispatch('comments/onWSCommentCreated', { projectId: comment.projectId, comment });
    }
  });

  app.trigger('onAfterCollaboration', {
    event: event.event,
    tasks: event.data.comments.map(i => i.taskId),
  });
}

export default onTaskCommentCreated;
